import { render, staticRenderFns } from "./ScansGallery.vue?vue&type=template&id=6573fa1c&scoped=true&"
import script from "./ScansGallery.vue?vue&type=script&lang=js&"
export * from "./ScansGallery.vue?vue&type=script&lang=js&"
import style0 from "./ScansGallery.vue?vue&type=style&index=0&id=6573fa1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573fa1c",
  null
  
)

export default component.exports